define((require) => {
    "use strict";

    var _            = require("underscore"),
        Backbone     = require("backbone"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/experience/action/sceneNavigation/SceneNavigationActionPropertiesView.tpl");

    /**
     * UI model class used to bind with the UI form.
     */
    var UIModel = Backbone.Model.extend({
        defaults: {
            type: "next",
            sceneNumber: 1
        }
    });

    /**
     * Properties view for a scene navigation action.
     *
     * @class SceneNavigationActionPropertiesView
     * @constructor
     *
     * @cfg {SceneNavigationAction} model The action to display in the view.
     */
    return ImprovedView.extend({

        _uiModel: null,

        template: template,

        uiModelBindings: {
            ".js-scene-navigation-type": "type",
            ".scene-navigation-scene-number": {
                observe: "sceneNumber",
                selectOptions: {
                    collection: function() {
                        var options = [];
                        for (var i = 1; i <= this.options.experience.get("scenes").length; i++) {
                            options.push({label: "Scene " + i, value: i});
                        }
                        return options;
                    }
                }
            }
        },

        onRender: function() {
            // Initialize the UI model from the real model
            var uiModelOptions;
            if (_.isString(this.model.get("target"))) {
                uiModelOptions = {
                    type: this.model.get("target"),
                    sceneNumber: 1
                };
            } else {
                uiModelOptions = {
                    type: "fixed",
                    sceneNumber: this.model.get("target")
                };
            }
            this._uiModel = new UIModel(uiModelOptions);

            // When the UI model updates, update the real model
            this.listenTo(this._uiModel, "change", function() {
                if (this._uiModel.get("type") === "fixed") {
                    this.model.set("target", this._uiModel.get("sceneNumber"));
                } else {
                    this.model.set("target", this._uiModel.get("type"));
                }
            });

            this.stickit(this._uiModel, this.uiModelBindings);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/sceneNavigation/SceneNavigationActionPropertiesView.js